import styled from 'styled-components'
import FlexBox from '../../components/FlexBox'
import Color from '../../utils/color'
import {
  Header, HeaderSmall, ButtonSmall, HeaderBig,
} from '../../components/Text'

import TextInput from '../../components/TextInput'

export const CheckoutContainer = styled.div`
  padding: 0 1rem 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const ProductListContainer = styled.div``

export const Row = styled(FlexBox)`
  padding-top: 0.5rem;
  justify-content: space-between;
`

export const StoreInfo = styled.div`
  padding: 0.5rem 0;
`

export const StoreName = styled(HeaderBig)`
  padding-bottom: 1rem;
`

export const FlexApart = styled.div`
`

export const PromoDrawer = styled(Row)`
  padding: 1rem 0;
`

export const PromoCodeBox = styled.div`
  margin: 0.5rem 0;
`

export const PromoCodeInput = styled(TextInput)`
  margin-bottom: 0.3rem;
`

export const CampaignTerms = styled.div`
  color: ${({ theme }) => theme.color.text};
  font-size: 0.7rem;
  font-weight: 500;
  padding-bottom: 1rem;
`

export const ProductItemContainer = styled(FlexBox)`
  position: relative;
  border-bottom: 1px solid #ddd;
  padding: 1rem 0;
  width: 100%;
`
export const ProductName = styled(Header)`
  width: 80%;
  padding-bottom: 0.5rem;
`

export const ProductDescription = styled(HeaderSmall)`
  width: 80%;
  padding-bottom: 0.5rem;
  font-size: 0.7rem;
`

export const ExtraName = styled(ButtonSmall)`
  padding: 0 4px;
`

export const ProductInfo = styled(FlexBox)`
  flex-direction: column;
`

export const Comment = styled(ButtonSmall)`
  color: ${Color.DarkGrey};
  padding: 4px 0;
`

export const ProductPrice = styled.div`
  position: absolute;
  top: 1rem;
  right: 0;
  font-size: 0.8rem;
  color: ${({ theme, discounted }) => discounted ? theme.color.accent : theme.color.primary};
`
